<template>
  <page-outline :title="$t('administration.user_edit')">
    <template slot="pageContent">
      <b-row class="pb-3 no-gutters">
        <back-button></back-button>
      </b-row>
      <spinner v-if="activateSpinner"></spinner>
      <form-accordion v-else  :isTitleUpperCase="false" :title="$t('administration.user')">
        <div class="form-group">
        </div>
        <b-row>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="login" isMandatory
              :inputLabel="$t('administration.login')" :placeholderValue="$t('administration.login')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="name" isMandatory
              :inputLabel="$t('administration.name')" :placeholderValue="$t('administration.name')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6" class="form-group">
            <label for="sel4">
              {{ $t('administration.active') }}
            </label>
            <select autocomplete="off" class="form-control" id="sel4" v-model="active" readonly>
              <option value="0"> {{ $t('administration.no') }} </option>
              <option value="2"> {{ $t('administration.yes') }} </option>
            </select>
          </b-col>
          <b-col sm="6" class="form-group">
            <label for="password">{{$t('common.pwd')}}</label>
            <div class="d-flex">
              <input v-model="password"
                     autocomplete="off"
                id="password"
                class="form-control inputAccordionForm h-30px"
                :type="passwordType">
                <div class="icon icon-password mt-2 pt-1 icon-field"
                  :class="[isPasswordFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"
                  @click="switchPasswordType">
                </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6" class="form-group">
            <label for="password-verif">{{$t('common.security.verif_password')}}</label>
            <div class="d-flex">
              <input v-model="passwordVerif"
                     autocomplete="off"
                id="password-verif"
                class="form-control inputAccordionForm h-30px"
                :type="passwordVerifType">
                <div class="icon icon-password mt-2 pt-1 icon-field"
                  :class="[isPasswordVerifFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"
                  @click="switchPasswordVerifType">
                </div>
            </div>
          </b-col>
          <b-col cols="6" sm="6" class="form-group">
            <b-form-checkbox v-model="firstLogin"
              value="1"
              unchecked-value="0"
              :disabled="receivedFirstLogin">
              <span>{{receivedFirstLogin ? $t('administration.reset_password_option') + ' ' + $t('common.active_par') : $t('administration.reset_password_option')}}</span>
            </b-form-checkbox>
          </b-col>
        </b-row>
        </form-accordion>
      <form-accordion v-if="!hasCountrySelector" :title="$t('administration.profile')"  :isTitleUpperCase="false">
        <b-row class="justify-content-start">
          <b-col cols="3">
            <a id="profile-picker-link" class="combo-list-field d-flex justify-content-between"
              href="#">
              <span :class="'fixed-span-size ' + (profileDisplay.nb > 0 ? 'filter-item-input-complete' : '')">{{ profileDisplay.label }}</span>
              <i class="fa-light fa-chevron-down" size="17px" id="status-chevron"></i>
            </a>
            <b-popover target="profile-picker-link"
              :title="$t('administration.select_profile')"
              triggers="focus" placement="bottom">
              <span v-for="(profile, index) in profiles" :key="'filtered-profile-' + profile.id_rights_profile + '-' + index">
                <b-form-checkbox v-model="profile.state"
                  :value="1"
                  :unchecked-value="0">
                  <span>{{ profile.libelle }}</span>
                </b-form-checkbox>
              </span>
            </b-popover>
          </b-col>
        </b-row>
      </form-accordion>
      <b-row class="accordionForm mt-3 justify-content-end form-group p-0 pr-2 no-gutters">
        <b-button variant="primary"
          @click="changeUser()">
          <i class="fa-light fa-save"></i>
          <span>{{ $t('common.sve') }}</span>
        </b-button>
      </b-row>
    </template>
  </page-outline>
</template>

<script>

import _ from 'lodash'

import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import Spinner from '@/components/common/spinner.vue'
import backButton from "@/components/common/backButton.vue"

import {reloadPage} from '@/helpers/routing'
// import {validateAccountFormat, validateEmail, validateSIREN, validatePhoneNumber} from '@/helpers/validator'

export default {
  name: 'EditUserCompany',
  components: {
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'spinner': Spinner,
    'back-button': backButton
  },
  props: ['idUserAcc', 'idCompany'],
  data () {
    return {
      activateSpinner: false,
      active: '',
      idProfile: '',
      firstLogin: '0',
      hrtpNorm: false,
      login: '',
      name: '',
      originalProfiles: [],
      password: '',
      passwordType: 'password',
      passwordVerif: '',
      passwordVerifType: 'password',
      psd2Norm: false,
      profiles: [],
      srtpNorm: false,
      receivedFirstLogin: false,
      refreshProfileList: false,
      Users: []
      // returnUrl: "/usercompany/" // '/detail/' + idCompany
    }
  },
  computed: {
    isNormSRTP () {
      return this.$engine.user.getUserNorm() === '1' || this.$engine.rights.rightIs('super_admin', true)
    },
    isNormHRTP () {
      return this.$engine.user.getUserNorm() === '2' || this.$engine.rights.rightIs('super_admin', true)
    },
    isNormPSD2 () {
      return this.$engine.user.getUserNorm() === '3' || this.$engine.rights.rightIs('super_admin', true)
    },
    isSelfSuperAdmin () {
      return this.$engine.company.profiles.filter(elem => elem.libelle.includes('Technical_')).length === 3
    },
    SRTPProfiles () {
      return this.profiles.filter(elem => {
        return elem.libelle.endsWith('_SRTP')
      })
    },
    HRTPProfiles () {
      return this.profiles.filter(elem => {
        return elem.libelle.endsWith('_HRTP')
      })
    },
    PSD2Profiles () {
      return this.profiles.filter(elem => {
        return elem.libelle.endsWith('_PSD2')
      })
    },
    hasCountrySelector () {
      return !this.$engine.rights.getCurrentCountry().idCountry
    },
    isPasswordFieldHidden () {
      return this.passwordType === 'password'
    },
    isPasswordVerifFieldHidden () {
      return this.passwordVerifType === 'password'
    },
    profileDisplayHRTP () {
      let realProfileList = this.profiles.filter(status => status.libelle.endsWith('_HRTP') && status.state === 1)
      let that = this
      if (realProfileList.length === 0) {
        return {
          label: this.$t('administration.select_profile'),
          nb: 0
        }
      } else if (realProfileList.length < 3) {
        return {
          label: realProfileList.map(elem => that.$t('rights.db_profiles.' + elem.libelle).slice(0, -5)).join(', '),
          nb: 1
        }
      } else {
        return {
          label: this.$t('administration.selected_profile_many', {nb: realProfileList.length}),
          nb: realProfileList.length
        }
      }
    },
    profileDisplayPSD2 () {
      let realProfileList = this.profiles.filter(status => status.libelle.endsWith('_PSD2') && status.state === 1)
      let that = this
      if (realProfileList.length === 0) {
        return {
          label: this.$t('administration.select_profile'),
          nb: 0
        }
      } else if (realProfileList.length < 3) {
        return {
          label: realProfileList.map(elem => that.$t('rights.db_profiles.' + elem.libelle).slice(0, -5)).join(', '),
          nb: 1
        }
      } else {
        return {
          label: this.$t('administration.selected_profile_many', {nb: realProfileList.length}),
          nb: realProfileList.length
        }
      }
    },
    profileDisplaySRTP () {
      let realProfileList = this.profiles.filter(status => status.libelle.endsWith('_SRTP') && status.state === 1)
      let that = this
      if (realProfileList.length === 0) {
        return {
          label: this.$t('administration.select_profile'),
          nb: 0
        }
      } else if (realProfileList.length < 3) {
        return {
          label: realProfileList.map(elem => that.$t('rights.db_profiles.' + elem.libelle).slice(0, -4)).join(', '),
          nb: 1
        }
      } else {
        return {
          label: this.$t('administration.selected_profile_many', {nb: realProfileList.length}),
          nb: realProfileList.length
        }
      }
    },
    profileDisplay () {
      let realProfileList = this.profiles.filter(status => status.state === 1)
      if (realProfileList.length === 0) {
        return {
          label: this.$t('administration.select_profile'),
          nb: 0
        }
      } else if (realProfileList.length < 3) {
        return {
          label: realProfileList.map(elem => elem.libelle).join(', '),
          nb: 1
        }
      } else {
        return {
          label: this.$t('administration.selected_profile_many', {nb: realProfileList.length}),
          nb: realProfileList.length
        }
      }
    }
  },
  created () {
    this.profiles = this.$engine.company.profiles
    this.atStart(this.idUserAcc)
  },
  methods: {
    atStart (val = 1) {
      let that = this
      that.Users = []
      that.$engine.usercompany.getUser(
        val,
        10,
        1
      ).then(resp => {
        let requests = {}
        if (resp.data && resp.data.users && resp.data.users.length > 0) {
          requests = resp.data.users[0]
          // remove all profiles that we are not able to edit
          // requests.Rights = requests.Rights.filter(elem => {
          //   return that.profiles.filter(innerElem => innerElem.libelle === elem.RightsProfileName).length
          // })
          that.Users.push(requests)
          this.updateModel()
        }
      }).catch(error => {
        that.activateSpinner = false
        if (!error.response.data.errorDescription) {
          error.response.data.errorDescription = error.response.data.description
        }
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    changeUser () {
      let that = this

      if (this.formHasError()) {
        return
      }

      let userRightGroups = this.profiles.filter(status => status.state === 1
          && ((that.isNormHRTP && that.hrtpNorm && status.libelle.endsWith('_HRTP'))
            || (that.isNormSRTP && that.srtpNorm && status.libelle.endsWith('_SRTP'))
            || (that.isNormPSD2 && that.psd2Norm && status.libelle.endsWith('_PSD2'))
            || (!status.libelle.endsWith('_HRTP') && !status.libelle.endsWith('_SRTP') && !status.libelle.endsWith('_PSD2')))).map(profile => parseInt(profile.id_rights_profile))
      let payload = {
        IdCompany: this.idCompany && this.idCompany !== 'undefined' ? this.idCompany : this.$engine.user.get().id,
        IdUserAccount: this.idUserAcc,
        IdRightsProfileAdd: userRightGroups.filter(rg => !that.originalProfiles.includes(rg)),
        IdRightsProfileDelete: that.originalProfiles.filter(ogProfile => !userRightGroups.includes(ogProfile)),
        UserAccount: {
          IsFirstLogin: this.firstLogin,
          IdUser: this.idUserAcc,
          Login: this.login,
          Name: this.name,
          Active: this.active,
          Password: this.password
        }
      }

      let adminRights = ['10','14','16']
      let allOriginalsProfiles = that.Users[0].Rights.map(elem => elem.IdRightProfile)
      let specialAction = 'NONE'
      let incomingUserRights = payload.IdRightsProfileAdd.concat(allOriginalsProfiles).map(String).filter(elem => !payload.IdRightsProfileDelete.map(String).includes(elem))
      // popup si ajout de super admin
      if (payload.IdRightsProfileAdd.length &&
        adminRights.every(elem => incomingUserRights.includes(elem))) {
        specialAction = 'ADD'
      } else if (adminRights.some(elem => payload.IdRightsProfileDelete.includes(parseInt(elem))) &&
        adminRights.every(elem => allOriginalsProfiles.includes(elem))) {
        specialAction = 'DEL'
      }

      if (specialAction === 'NONE') {
        this.$engine.usercompany.editUser(payload)
        .then(() => {
          that.$f7.modal({
            title: that.$i18n.t('administration.edit_user'),
            buttons: [
              {
                text: 'OK',
                onClick: function () {
                  return
                }
              }
            ]
          })
          //that.$bus.$emit('switch-selected-menu', '/usercompany/')
          reloadPage(that, {url: /detailusercompany/ + that.idUserAcc + '/' + that.idCompany})
        })
        .catch(e => {
          if (!e.response.data.errorDescription) {
            e.response.data.errorDescription = e.response.data.description
          }
          errorMessageAlert(e, that)
        })
      } else {
        if (!this.isSelfSuperAdmin) {
          // popup pas le droit d'ajouter ou enlever un super admin si tu l'es pas
          that.$f7.modal({
            title: specialAction === 'ADD' ? that.$i18n.t('administration.super_admin_add_insufficient_rights') : that.$i18n.t('administration.super_admin_remove_insufficient_rights'),
            buttons: [
              {
                text: 'OK',
                onClick: function () {
                  return
                }
              }
            ]
          })
          return
        }
        that.$f7.modal({
          title: specialAction === 'ADD' ? that.$i18n.t('administration.super_admin_add_confirmation') : that.$i18n.t('administration.super_admin_remove_confirmation'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                that.$engine.usercompany.editUser(payload)
                .then(() => {
                  that.$f7.modal({
                    title: that.$i18n.t('administration.edit_user'),
                    buttons: [
                      {
                        text: 'OK',
                        onClick: function () {
                          return
                        }
                      }
                    ]
                  })
                  //that.$bus.$emit('switch-selected-menu', '/usercompany/')
                  reloadPage(that, {url: /detailusercompany/ + that.idUserAcc + '/' + that.idCompany})
                })
                .catch(e => {
                  if (!e.response.data.errorDescription) {
                    e.response.data.errorDescription = e.response.data.description
                  }
                  errorMessageAlert(e, that)
                })
              }
            },
            {
              text: 'Cancel',
              onClick: function () {
                return
              }
            }
          ]
        })
      }
    },
    formHasError () {
      let regexPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_])[A-Za-z\d@$!%*?&_]{15,40}$/
      if (this.login === undefined || this.login === '') {
        this.okMessageBox(this.$t('usercompany.missing_login'))
        return true
      }
      if (this.name === undefined || this.name === '') {
        this.okMessageBox(this.$t('usercompany.missing_name'))
        return true
      }
      if (this.passwordVerif && (this.password === undefined || this.password === '')) {
        this.okMessageBox(this.$t('errors.new_pwd_mssng'))
        return true
      }
      if (this.password && (this.passwordVerif === undefined || this.passwordVerif === '')) {
        this.okMessageBox(this.$t('usercompany.missing_password_verif'))
        return true
      }
      if (this.password && !regexPassword.test(this.password)) {
        this.okMessageBox(this.$t('profilesPage.password_wrong_format'))
        return true
      }
      if (this.passwordVerif !== this.password) {
        this.okMessageBox(this.$t('usercompany.passwords_not_matching'))
        return true
      }
      // if (!this.profiles.filter(profile => profile.state === 1
      //     && ((that.hrtpNorm && profile.libelle.endsWith('_HRTP'))
      //       || (that.srtpNorm && profile.libelle.endsWith('_SRTP'))
      //       || (that.psd2Norm && profile.libelle.endsWith('_PSD2'))
      //       || (!profile.libelle.endsWith('_HRTP')
      //         && !profile.libelle.endsWith('_SRTP')
      //         && !profile.libelle.endsWith('_PSD2')))).length) {
      //         this.okMessageBox(this.$t('usercompany.missing_profile'))
      //         return true
      //       }
      return false
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    switchPasswordType () {
      if (this.passwordType === 'password') {
        this.passwordType = 'text'
      } else {
        this.passwordType = 'password'
      }
    },
    switchPasswordVerifType () {
      if (this.passwordVerifType === 'password') {
        this.passwordVerifType = 'text'
      } else {
        this.passwordVerifType = 'password'
      }
    },
    updateFilteredNorms () {
      this.filteredNorms = _.cloneDeep(this.profiles.filter(profile => {
        return profile.libelle.startsWith('Norm_')
      }))
      let that = this
      this.filteredNorms.forEach(profile => {
        profile.active = 0
        profile.libelle = that.$i18n.t('requestToPay.norms.' + profile.libelle.split('_')[1])
      })
      this.filteredNorms.sort(function (a, b) {
        return a.libelle < b.libelle ? -1 : 1
      })
    },
    updateModel () {
      let that = this
      this.login = this.Users[0].Login
      this.active = this.Users[0].Active
      this.firstLogin = this.Users[0].IsFirstLogin
      if(this.Users[0].IsFirstLogin === '1') {
        this.receivedFirstLogin = true
      }
      // this.type = this.Users[0].user_account.type
      this.originalProfiles = that.Users[0].Rights.filter(elem =>
        that.profiles.map(elem => elem.id_rights_profile).includes(elem.IdRightProfile) &&
        ((that.isNormSRTP && elem.RightsProfileName.endsWith('_SRTP'))
        || (that.isNormHRTP && elem.RightsProfileName.endsWith('_HRTP'))
        || (that.isNormPSD2 && elem.RightsProfileName.endsWith('_PSD2'))
        || (!elem.RightsProfileName.endsWith('_SRTP') && !elem.RightsProfileName.endsWith('_HRTP') && !elem.RightsProfileName.endsWith('_PSD2')))
      ).map(elem => parseInt(elem.IdRightProfile))
      this.name = this.Users[0].Name
      this.idProfile = this.Users[0].Rights && this.Users[0].Rights.length ? this.Users[0].Rights[0].IdRightProfile : ''
      this.profiles.forEach(profile => {
        if (that.Users[0].Rights.filter(item => item.IdRightProfile === profile.id_rights_profile).length) {
          profile.state = 1
        }
      })
      this.profiles = _.cloneDeep(this.profiles).sort((a, b) => {
        return a.libelle.toUpperCase() > b.libelle.toUpperCase() ? 1 : -1
      })
      if (this.profiles.filter(elem => elem.libelle.endsWith('_HRTP') && elem.state === 1).length) {
        this.hrtpNorm = true
      }
      if (this.profiles.filter(elem => elem.libelle.endsWith('_SRTP') && elem.state === 1).length) {
        this.srtpNorm = true
      }
      if (this.profiles.filter(elem => elem.libelle.endsWith('_PSD2') && elem.state === 1).length) {
        this.psd2Norm = true
      }
      this.updateFilteredNorms()
      this.refreshProfileList = !this.refreshProfileList
      // this.permissions = this.Users[0].user_account.permissions
      // this.activation_code = this.Users[0].user_account.activation_code
      // this.date_activate_code = this.Users[0].user_account.date_activate_code
      // this.last_account_load = this.Users[0].user_account.last_account_load
      // this.last_service_load = this.Users[0].user_account.last_service_load
      // this.is_first_login = this.Users[0].user_account.is_first_login
      // this.connect_by = this.Users[0].user_account.connect_by
    },
  }
}
</script>
